/**
 * Resolve public payment confirmation path from payment reference / type.
 * Used by ALATPay checkout and contribution confirmation redirect.
 */
export function paymentConfirmationPath(reference, paymentType = null) {
  const ref = String(reference || "");
  const type = String(paymentType || "").toLowerCase();

  if (
    ref.startsWith("PAYMENT_INVESTMENT_") ||
    type === "investment"
  ) {
    return "/invest/payment/confirmation";
  }
  if (
    ref.startsWith("PAYMENT_MARKETPLACE_") ||
    type === "marketplace"
  ) {
    return "/invest/marketplace/payment/confirmation";
  }
  return "/member/payment/confirmation";
}

/**
 * @param {string|null} reference
 * @param {string|null} paymentType
 * @param {Record<string, string|number|boolean|null|undefined>} [extraParams]
 */
export function paymentConfirmationUrl(reference, paymentType = null, extraParams = {}) {
  const path = paymentConfirmationPath(reference, paymentType);
  const params = new URLSearchParams();
  if (reference) {
    params.set("reference", String(reference));
  }
  Object.entries(extraParams || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

export function investmentHistoryPath() {
  return "/invest/requests?filter=investment";
}

export function marketplaceHistoryPath() {
  return "/invest/requests?filter=marketplace";
}

/** Best-effort extract of ALATPay transaction UUID from plugin callback payload. */
export function extractAlatpayTransactionId(response) {
  if (!response || typeof response !== "object") return null;
  const candidates = [
    response.id,
    response.transactionId,
    response.TransactionId,
    response.transaction_id,
    response?.data?.id,
    response?.data?.transactionId,
    response?.data?.TransactionId,
    response?.Data?.id,
    response?.Data?.Id,
    response?.Value?.Data?.id,
    response?.Value?.Data?.Id,
    response?.value?.data?.id,
    response?.customer?.transactionId,
    response?.Customer?.TransactionId,
    response?.data?.customer?.transactionId,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim() !== "") {
      return value.trim();
    }
  }
  return null;
}
